import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import "./Career.css";
import { API_BASE, fetchJson } from "../../api";

const Career = () => {
  const [selectedJob, setSelectedJob] = useState(null);
  const [jobs, setJobs] = useState([]);
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    resume: null,
  });

  useEffect(() => {
    let mounted = true;
    fetchJson("careers")
      .then((data) => {
        if (mounted && data && Array.isArray(data.careers)) {
          setJobs(data.careers);
        }
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  const handleApply = (job) => {
    setSelectedJob(job);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", form.name);
    formData.append("phone", form.phone);
    formData.append("email", form.email);
    formData.append("job_title", selectedJob.title);
    formData.append("resume", form.resume);

    try {
      const res = await fetch(`${API_BASE}/jobs/apply`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (data.status) {
        alert("Application submitted successfully!");
        setSelectedJob(null);
      } else {
        alert(data.message);
      }
    } catch (err) {
      alert("Server error");
    }
  };

  return (
    <div className="career-page">

      {/* ✅ SEO START */}
      <Helmet>
        <title>IVF Jobs in Ambala | Careers at Amaanat IVF</title>

        <meta
          name="description"
          content="Explore job opportunities at Amaanat IVF in Ambala. Apply for embryologist, nursing, and receptionist jobs in fertility clinic."
        />

        <link rel="canonical" href="https://amaanativf.com/career" />

        {/* ✅ Job Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            "itemListElement": jobs.map((job, index) => ({
              "@type": "ListItem",
              "position": index + 1,
              "item": {
                "@type": "JobPosting",
                "title": job.title,
                "description": job.description,
                "employmentType": job.type,
                "jobLocation": {
                  "@type": "Place",
                  "address": {
                    "@type": "PostalAddress",
                    "addressLocality": "Ambala",
                    "addressCountry": "IN"
                  }
                },
                "hiringOrganization": {
                  "@type": "Organization",
                  "name": "Amaanat IVF"
                }
              }
            }))
          })}
        </script>
      </Helmet>
      {/* ✅ SEO END */}

      {/* HERO */}
      <div className="career-hero">
        <h1>Careers at Amaanat IVF Ambala</h1>
        <p>Join Amaanat IVF & Fertility Team</p>
      </div>

      {/* JOB LIST */}
      <div className="career-container">
        <h2>Current Job Openings</h2>

        <div className="job-list">
          {jobs.length === 0 && (
            <p style={{ textAlign: 'center', padding: '30px 0', color: '#666' }}>
              No open positions right now — check back soon.
            </p>
          )}
          {jobs.map((job) => (
            <div className="job-card" key={job.id}>
              <h3>{job.title}</h3>

              <div className="job-meta">
                <span>📍 {job.location}</span>
                <span>💼 {job.type}</span>
                <span>⏳ {job.experience}</span>
              </div>

              <p>{job.description}</p>

              <button
                className="apply-btn"
                onClick={() => handleApply(job)}
              >
                Apply Now
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* APPLY MODAL */}
      {selectedJob && (
        <div className="apply-modal">
          <div className="apply-box">
            <h3>Apply for {selectedJob.title}</h3>

            <form onSubmit={handleSubmit}>
              <input type="text" placeholder="Full Name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              <input type="tel" placeholder="Phone Number" required value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
              <input type="email" placeholder="Email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
              <input type="file" accept=".pdf,.doc,.docx" onChange={(e) => setForm({ ...form, resume: e.target.files[0] })} />

              <div className="modal-actions">
                <button type="submit">Submit</button>
                <button type="button" onClick={() => setSelectedJob(null)} className="cancel-btn">
                  Cancel
                </button>
              </div>
            </form>

            <a
              href={`mailto:hr@amaanativf.com?subject=Application for ${selectedJob.title}`}
              className="mail-option"
            >
              Or Apply via Email
            </a>
          </div>
        </div>
      )}

    </div>
  );
};

export default Career;